import {TvModuleName} from './tv-module-name';
import {TvModuleDefinition} from './tv-module-definition';
import {TvModule} from './tv-module';
import {version} from '../utils/version';
import {inject} from '../di';

function legacyLoad(moduleName: TvModuleName): Promise<TvModule> {
  return $.cachedScript('modules/' + moduleName + '/' + moduleName + '.js?v=' + version.v).then(
    () => window[moduleName] as TvModule,
  );
}

export const tvModulesConfig: TvModuleDefinition[] = [
  {
    name: TvModuleName.Svg,
    load: () => import('../../modules/svg/svg.module').then((m) => inject(m.SvgModule)),
  },
  {
    name: TvModuleName.Information,
    deps: [TvModuleName.Svg],
    load: () => import('../../modules/information/information.module').then((m) => inject(m.InformationModule)),
  },
  {
    name: TvModuleName.Stat,
    load: () => import('../../modules/stat/stat.module').then((m) => inject(m.StatModule)),
  },
  {
    name: TvModuleName.ViewBill,
    load: () => import('../../modules/view-bill/view-bill.module').then((m) => inject(m.ViewBillModule)),
  },
  {
    name: TvModuleName.RemoteControl,
    load: () => legacyLoad(TvModuleName.RemoteControl),
  },
  {
    name: TvModuleName.VirtualScroll,
    load: () => legacyLoad(TvModuleName.VirtualScroll),
  },
  {
    name: TvModuleName.TvMosaic,
    deps: [TvModuleName.Epg],
    load: () => legacyLoad(TvModuleName.TvMosaic),
  },
  {
    name: TvModuleName.Services,
    deps: [TvModuleName.Svg],
    load: () => import('../../modules/services/services.module').then((m) => inject(m.ServicesModule)),
  },
  {
    name: TvModuleName.Shop,
    deps: [TvModuleName.Svg, TvModuleName.Services],
    load: () => import('../../modules/shop/shop.module').then((m) => inject(m.ShopModule)),
  },
  {
    name: TvModuleName.Epg,
    load: () => legacyLoad(TvModuleName.Epg),
  },
  {
    name: TvModuleName.CustomNotification,
    load: () =>
      import('../../modules/custom-notification/custom-notification.module').then((m) =>
        inject(m.CustomNotificationModule),
      ),
  },
  {
    name: TvModuleName.Apps,
    load: () => import('../../modules/apps/apps.module').then((m) => inject(m.AppsModule)),
  },
  {
    name: TvModuleName.Menu,
    deps: [TvModuleName.Svg],
    load: () => import('../../modules/menu/menu.module').then((m) => inject(m.MenuModule)),
  },
  {
    name: TvModuleName.Messages,
    deps: [TvModuleName.CustomNotification],
    load: () => legacyLoad(TvModuleName.Messages),
  },
  {
    name: TvModuleName.ScrollContainer,
    load: () => legacyLoad(TvModuleName.ScrollContainer),
  },
  {
    name: TvModuleName.PictureMode,
    load: () => legacyLoad(TvModuleName.PictureMode),
  },
  {
    name: TvModuleName.VerticalGallery,
    load: () =>
      import('../../modules/vertical-gallery/vertical-gallery.module').then((m) => inject(m.VerticalGalleryModule)),
  },
  {
    name: TvModuleName.YandexStation,
    load: () => legacyLoad(TvModuleName.YandexStation),
  },
  {
    name: TvModuleName.AirPlayBuiltIn,
    load: () =>
      import('../../modules/air-play-built-in/air-play-built-in.module').then((m) => inject(m.AirPlayBuiltInModule)),
  },
  {
    name: TvModuleName.AirStream,
    load: () => import('../../modules/air-stream/air-stream.module').then((m) => inject(m.AirStreamModule)),
  },
  {
    name: TvModuleName.Chromecast,
    load: () => import('../../modules/chromecast/chromecast.module').then((m) => inject(m.ChromecastModule)),
  },
  {
    name: TvModuleName.CSCast,
    load: () => import('../../modules/cs-cast/cs-cast.module').then((m) => inject(m.CsCastModule)),
  },
  {
    name: TvModuleName.Disney,
    load: () => import('../../modules/disney/disney.module').then((m) => inject(m.DisneyModule)),
  },
  {
    name: TvModuleName.DoorEye,
    load: () => import('../../modules/door-eye/door-eye.module').then((m) => inject(m.DoorEyeModule)),
  },
  {
    name: TvModuleName.GoogleCastBuiltIn,
    load: () => legacyLoad(TvModuleName.GoogleCastBuiltIn),
  },
  {
    name: TvModuleName.Housekeeping,
    load: () => import('../../modules/housekeeping/housekeeping.module').then((m) => inject(m.HousekeepingModule)),
  },
  {
    name: TvModuleName.LgAirServer,
    load: () => import('../../modules/lg-air-server/lg-air-server.module').then((m) => inject(m.LgAirServerModule)),
  },
  {
    name: TvModuleName.Logout,
    load: () => import('../../modules/logout/logout.module').then((m) => inject(m.LogoutModule)),
  },
  {
    name: TvModuleName.Media2,
    load: () => legacyLoad(TvModuleName.Media2),
  },
  {
    name: TvModuleName.Mod,
    load: () => legacyLoad(TvModuleName.Mod),
  },
  {
    name: TvModuleName.OldMod,
    load: () => legacyLoad(TvModuleName.OldMod),
  },
  {
    name: TvModuleName.PeninsulaRs232,
    load: () => legacyLoad(TvModuleName.PeninsulaRs232),
  },
  {
    name: TvModuleName.PeninsulaVod,
    load: () => legacyLoad(TvModuleName.PeninsulaVod),
  },
  {
    name: TvModuleName.Radio,
    load: () => legacyLoad(TvModuleName.Radio),
  },
  {
    name: TvModuleName.RemoteState,
    load: () => legacyLoad(TvModuleName.RemoteState),
  },
  {
    name: TvModuleName.Sanatorium,
    load: () => legacyLoad(TvModuleName.Sanatorium),
  },
  {
    name: TvModuleName.ScandicWelcome,
    deps: [TvModuleName.Welcome],
    load: () =>
      import('../../modules/scandic-welcome/scandic-welcome.module').then((m) => inject(m.ScandicWelcomeModule)),
  },
  {
    name: TvModuleName.Welcome,
    load: () => import('../../modules/welcome/welcome.module').then((m) => inject(m.WelcomeModule)),
  },
  {
    name: TvModuleName.Screensaver,
    load: () => legacyLoad(TvModuleName.Screensaver),
  },
  {
    name: TvModuleName.Tests,
    load: () => legacyLoad(TvModuleName.Tests),
  },
  {
    name: TvModuleName.UpdateInfoGorki,
    load: () => legacyLoad(TvModuleName.UpdateInfoGorki),
  },
  {
    name: TvModuleName.VerticalChannel,
    deps: [TvModuleName.TvMosaic, TvModuleName.Epg],
    load: () => legacyLoad(TvModuleName.VerticalChannel),
  },
  {
    name: TvModuleName.Vod,
    load: () => legacyLoad(TvModuleName.Vod),
  },
  {
    name: TvModuleName.VodHtml5,
    load: () => legacyLoad(TvModuleName.VodHtml5),
  },
  {
    name: TvModuleName.WakeUpCall,
    load: () => legacyLoad(TvModuleName.WakeUpCall),
  },
  {
    name: TvModuleName.WakeUpCall2,
    load: () => legacyLoad(TvModuleName.WakeUpCall2),
  },
  // Widgets (loads automatically by MenuModule, if present in menu):
  {
    name: TvModuleName.Flights,
    load: () => import('../../modules/flights/flights.module').then((m) => inject(m.FlightsModule)),
  },
  {
    name: TvModuleName.Weather,
    load: () => import('../../modules/weather/weather.module').then((m) => inject(m.WeatherModule)),
  },
  {
    name: TvModuleName.GorkiGorod,
    load: () => import('../../modules/gorki-gorod/gorki-gorod.module').then((m) => inject(m.GorkiGorodModule)),
  },
];
